export default __webpack_public_path__ + "static/media/check-in.74ceee69.svg";